import Axios, * as others from 'axios';
import React, { Component,useEffect,useState } from "react";
import URL from '../../Environment';


const LastNews = () => {

  const [data0, setData0] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

  const fetchData = async () => {
    // try {

      Axios.get(URL + 'api/Advertise/GetLatestNews').then((response) => {
        const res0 = response.data.ads0;
        const res1 = response.data.ads1;
        const res2 = response.data.ads2;
        console.log(res0);
        console.log(res1);
        console.log(res2);

        setData0(response.data.ads0);
        setData1(response.data.ads1);
        setData2(response.data.ads2);

        setLoading(false);   

      }).catch((error) => {
        setError(error);
        setLoading(false); 

      });
  };

  // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
  fetchData();

  // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
  return () => {
    // ทำการคืนการทำงานที่ต้องการ (cleanup)
    //console.log('Component unmounted');
  };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (

              <div className="col-md-3 sidebar">
                <aside className="widget-post">
                  <h2 className="widget-title">ข่าวล่าสุด</h2>
                  <div className="item-recent clearfix">
                    <img id="img1" src={"Img/Advertise/" + data0.id + "/" + data0.img} style={{width: 70}} />
                      <h5 className="title">
                        <a href="advertise" id="lblnews1" target="_blank">{data0.topic}</a>
                      </h5>
                      <div className="date-recent">
                        <label id="lbltime1">{data0.update_day}</label>
                      </div>
                  </div>
                  <br/>
                  <div className="item-recent clearfix">
                    <img id="img2" src={"Img/Advertise/" + data1.id + "/" + data1.img} style={{width: 70}} />
                      <h5 className="title">
                        <a href="advertise" id="lblnews2" target="_blank">{data1.topic}</a>
                      </h5>
                      <div className="date-recent">
                        <label id="lbltime2">{data1.update_day}</label>
                      </div>
                  </div>
                  <br/>
                  <div className="item-recent clearfix">
                    <img id="img3" src={"Img/Advertise/" + data2.id + "/" + data2.img} style={{width: 70}} />
                      <h5 className="title">
                        <a href="advertise" id="lblnews3" target="_blank">{data2.topic}</a>
                      </h5>
                      <div className="date-recent">
                        <label id="lbltime3">{data2.update_day}</label>
                      </div>
                  </div>
                </aside>
              </div>
              
  );

};



export default LastNews;
